// src/screens/admin/subjects/subjects.js
import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Badge, Modal, Form, Table } from 'react-bootstrap';
import AdminLayout from '../../../layouts/admin/adminlayout/AdminLayout';
import '../../../assets/css/admin/adminSubjects/AdminSubjects.css';
import AppContext from '../../../context/AppContext';
import axios from 'axios';
const Subjects = () => {
  const { baseUrl } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [subjectId, setSubjectId] = useState();
  const [subjectName, setSubjectName] = useState('');
  const [status, setStatus] = useState('active');
  const [subjects, setSubjects] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  const createSubject = () => {
    const formData = new FormData();
    formData.append("name", subjectName);
    formData.append("status", status);
    axios
      .post(`${baseUrl}/admin/subject/createSubject`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        setShowModal(false);
        console.log(response.data);
        viewAllSubjects();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateSubject = () => {

    const formData = new FormData();
    formData.append("id",subjectId );
    formData.append("name", subjectName);
    formData.append("status", status);
    axios
      .post(`${baseUrl}/admin/subject/updateSubject`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        setShowModal(false);
        console.log(response.data);
        viewAllSubjects();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteSubject = () => {

    const formData = new FormData();
    formData.append("id",subjectId );
    axios
      .post(`${baseUrl}/admin/subject/deleteSubject`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        setShowModal(false);
        console.log(response.data);
        viewAllSubjects();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const viewAllSubjects = () => {
    axios
      .post(`${baseUrl}/admin/subject/viewAllSubjects`)
      .then((response) => {
        setSubjects(response.data.subjects);
      })
      .catch((error) => {
        console.log(error);
      });
  };



  const handleEditSubject = (subject) => {
    setSelectedSubject(subject);
    setSubjectId(subject.id);
    setSubjectName(subject.name);
    setStatus(subject.status);
    setShowEditModal(true);
  };

  const handleDeleteSubject = (id) => {
    if (window.confirm('Are you sure you want to delete this subject?')) {
      setSubjects(subjects.filter(s => s.id !== id));
    }
  };

  const handleToggleStatus = (id) => {
    // setSubjects(subjects.map(d =>
    //   d.id === id ? { ...d, status: d.status === 'active' ? 'inactive' : 'active' } : d
    // ));
  };
  useEffect(() => {
    viewAllSubjects();
  }, []);
  return (
    <AdminLayout>
      <div className="subjects-page">
        {/* Page Header */}
        <div className="page-header mb-4">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="page-title">
                <span className="page-icon">🔖</span>
                Subjects Management
              </h2>
              <p className="text-muted">Manage educational subjects and categories</p>
            </div>
            <Button variant="primary" size="lg" className="add-subject-btn" onClick={() => setShowModal(true)}>
              Add New Subject
            </Button>
          </div>
        </div>

        {/* Stats Cards */}
        <Row className="mb-4">
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-blue">
              <Card.Body>
                <div className="stat-icon">📚</div>
                <div className="stat-info">
                  <h3>{subjects.length}</h3>
                  <p>Total subjects</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-green">
              <Card.Body>
                <div className="stat-icon">✅</div>
                <div className="stat-info">
                  <h3>{subjects.filter(d => d.status === 'active').length}</h3>
                  <p>Active subjects </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-purple">
              <Card.Body>
                <div className="stat-icon">👥</div>
                <div className="stat-info">
                  <h3>{subjects.reduce((sum, d) => sum + d.totalGroups, 0)}</h3>
                  <p>Total Groups</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3} md={6} className="mb-3">
            <Card className="stat-card stat-card-orange">
              <Card.Body>
                <div className="stat-icon">👨‍🎓</div>
                <div className="stat-info">
                  <h3>{subjects.reduce((sum, d) => sum + d.totalStudents, 0)}</h3>
                  <p>Total Students</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* subjects Grid */}
        <Row>
          {subjects.map((subject) => (
            <Col lg={4} md={6} key={subject.id} className="mb-4">
              <Card className="subject-card">
                <Card.Body>
                  {/* <div className="subject-header" style={{ borderLeftColor: subject.color }}>
                    <div className="subject-icon" style={{ backgroundColor: subject.color }}>
                      {subject.icon}
                    </div> */}
                  <div className="flex-grow-1">
                    <h5 className="subject-name">{subject.name}</h5>
                    <Badge bg={subject.status === 'active' ? 'success' : 'secondary'}>
                      {subject.status}
                    </Badge>
                  </div>
                  {/* </div> */}

                  {/* <p className="subject-description">{subject.description}</p>

                  <div className="subject-categories mb-3">
                    <small className="text-muted d-block mb-2">Categories:</small>
                    <div className="d-flex flex-wrap gap-1">
                      {subject.categories.map((category, idx) => (
                        <Badge key={idx} bg="light" text="dark" className="category-badge">
                          {category}
                        </Badge>
                      ))}
                    </div>
                  </div> */}

                  <div className="subject-stats mb-3">
                    <div className="stat-item">
                      <i className="bi bi-people-fill"></i>
                      <span>{subject.totalGroups} Groups</span>
                    </div>
                    <div className="stat-item">
                      <i className="bi bi-person-fill"></i>
                      <span>{subject.totalStudents} Students</span>
                    </div>
                  </div>

                  <div className="subject-actions">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => handleEditSubject(subject)}
                    >
                      <i className="bi bi-pencil"></i> Edit
                    </Button>
                    <Button
                      variant={subject.status === 'active' ? 'outline-warning' : 'outline-success'}
                      size="sm"
                      onClick={() => handleToggleStatus(subject.id)}
                    >
                      <i className={`bi bi-${subject.status === 'active' ? 'pause' : 'play'}-circle`}></i>
                      {subject.status === 'active' ? 'Deactivate' : 'Activate'}
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleDeleteSubject(subject.id)}
                    >
                      <i className="bi bi-trash"></i> Delete
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Add subject Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Add New Subject</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={8}>
                  <Form.Group className="mb-3">
                    <Form.Label>Subject Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter subject name"
                      value={subjectName}
                      onChange={(event) => { setSubjectName(event.target.value) }}
                    />
                  </Form.Group>
                </Col>
                {/* <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Icon (Emoji)</Form.Label>
                    <Form.Control type="text" placeholder="🎓" />
                  </Form.Group>
                </Col> */}
              </Row>

              {/* <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control as="textarea" rows={3} placeholder="Enter subject description" />
              </Form.Group> */}

              {/* <Form.Group className="mb-3">
                <Form.Label>Color</Form.Label>
                <Form.Control type="color" defaultValue="#4a90e2" />
              </Form.Group> */}

              {/* <Form.Group className="mb-3">
                <Form.Label>Categories (comma separated)</Form.Label>
                <Form.Control type="text" placeholder="Category 1, Category 2, Category 3" />
              </Form.Group> */}

              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={status}
                  onChange={(event) => { setStatus(event.target.value) }}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
            <Button variant="primary" onClick={createSubject}>Add Subject</Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Subject Modal */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Edit Subject</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedSubject && (
              <Form>
                <Row>
                  <Col md={8}>
                    <Form.Group className="mb-3">
                      <Form.Label>Subject Name</Form.Label>
                      <Form.Control type="text" defaultValue={selectedSubject.name} />
                    </Form.Group>
                  </Col>
                  {/* <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Icon (Emoji)</Form.Label>
                      <Form.Control type="text" defaultValue={selectedsubject.icon} />
                    </Form.Group>
                  </Col> */}
                </Row>

                {/* <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control as="textarea" rows={3} defaultValue={selectedsubject.description} />
                </Form.Group> */}

                {/* <Form.Group className="mb-3">
                  <Form.Label>Color</Form.Label>
                  <Form.Control type="color" defaultValue={selectedsubject.color} />
                </Form.Group> */}

                {/* <Form.Group className="mb-3">
                  <Form.Label>Categories</Form.Label>
                  <Form.Control type="text" defaultValue={selectedsubject.categories.join(', ')} />
                </Form.Group> */}

                <Form.Group className="mb-3">
                  <Form.Label>Status</Form.Label>
                  <Form.Select defaultValue={selectedSubject.status}>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Form>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>Cancel</Button>
            <Button variant="primary">Save Changes</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </AdminLayout>
  );
};

export default Subjects;